import EventCTA from './EventCTA';

export default EventCTA;
